<div *ngIf="isEnhancedGlobalSearchEnabled" class="global-search" (click)="$event.stopPropagation()">
  <app-input type="text" styleClassContainer="width-90p" font-size="12" theme="secondary" [value]="query" placeholder="Search customers, vehicles & ROs"
    leftIcon="fal fa-search" (appChange)="handleChange($event)" [autoFocus]="true">
  </app-input>

  <app-global-search-item subId="0" *ngIf="query.length >= 2" [isROPrioritiesEnabled]="isROPrioritiesEnabled"
    [isEnhancedGlobalSearchEnabled]="isEnhancedGlobalSearchEnabled" [defaultPriority]="defaultPriority" [data]="results"
    [globalSearchIncludeArchivedOrders]="globalSearchIncludeArchivedOrders" [isMyFleetCenterEnabled]="isMyFleetCenterEnabled"
    [close]="close" [query]="query" (clearModal)="resetSearch($event)"></app-global-search-item>
</div>

<div *ngIf="!isEnhancedGlobalSearchEnabled" class="global-search">
  <app-auto-complete placeholder="Search customers, vehicles & ROs" styleClassListWrapper="w-100"
    styleClassInputWrapper="bg-white" leftIcon="fal fa-search font-gray" noRecordIcon="fal fa-user font-16 pr-2"
    noRecordText="No customers match your search" id="ac-gloabal-search-customer{{subId}}"
    listId="ac-gloabal-search-customer-list{{subId}}" [highlightFirstOption]="true" [hasSearchIcon]="true"
    [isLoading]="isLoading" [showSelectedValue]="false" theme="border" scrollHeight="400px" itemWidth="450px"
    [autoFocus]="subId === '2' ? true: false" [suggestions]="results" [closeOnSelection]="true"
    [openDropdownOnGetResult]="true" [hasEditableField]="false" (appSelect)="handleSelect($event)"
    (appCompletedMethod)="pageIndex = 0; totalPages = 0; handleSearch($event)" (appClear)="handleClear()"
    (appEnter)="onSearchEnter()">
    <ng-template let-item let-index="index" appTemplate="item" let-close="close">
      <app-global-search-item subId="0" [isROPrioritiesEnabled]="isROPrioritiesEnabled"
        [isEnhancedGlobalSearchEnabled]="isEnhancedGlobalSearchEnabled" [globalSearchIncludeArchivedOrders]="globalSearchIncludeArchivedOrders" [defaultPriority]="defaultPriority"
        [data]="item" [close]="close" [query]="query" (clearModal)="resetSearch($event)"></app-global-search-item>

      <p *ngIf="index === results.length - 1 && pageIndex < totalPages && results.length < totalRecords"
        class="font-primary mb-0 p-2 flex-center-center" (click)="handleShowMore($event)">
        Show more
        <i *ngIf="isLoadingMore" class="fal fa-spinner rotate ml-2"></i>
      </p>
    </ng-template>
  </app-auto-complete>
</div>
